import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import MagicLinkViewView from './MagicLinkView.view';

// Entity id → display name. Kept in sync with the DB constants (1/2/3 are stable).
const ENTITY_NAME_BY_ID = {
  1: 'Abraaj Water',
  2: 'Lofat Lifestyle',
  3: 'Regency Kuwait',
};

export default function MagicLinkView() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Uses axios directly (not the shared api util) because this route is
    // public — the viewer has no auth token yet. Backend at
    // GET /api/tickets/view/:token returns { ticket, notes, history,
    // dept_actions, readonly }. dept_actions are internal ops notes and
    // intentionally not surfaced to external stakeholders.
    axios.get(`/api/tickets/view/${token}`)
      .then((res) => { setData(res.data); setLoading(false); })
      .catch((err) => {
        const msg = err?.response?.status === 410
          ? 'This link has expired.'
          : 'This link is invalid or has expired.';
        setError(msg);
        setLoading(false);
      });
  }, [token]);

  const ticket = data?.ticket || null;
  const entityName = ticket
    ? (ticket.entity_name || ENTITY_NAME_BY_ID[ticket.entity_id] || '')
    : '';

  return (
    <MagicLinkViewView
      ticket={ticket}
      notes={data?.notes || []}
      history={data?.history || []}
      loading={loading}
      error={error}
      entityName={entityName}
    />
  );
}
